<template>
  <LcModal
    :close-triggers="['click-outside', 'close-button', 'escape']"
    :container-class="$style.modal"
    spacing="medium"
    :tracking="{
      action: 'play_high_frequency_game',
      topicKey: 'high-frequency-game-compliance-modal',
    }"
    @close="emit('close')"
  >
    <template #header>
      <span class="inline-block w-full text-left headline-h4-headline">
        {{ $t('highfrequencygame.compliance.modal.headline') }}
      </span>
    </template>

    <i18n-t class="text-left pb-200" keypath="highfrequencygame.compliance.modal.hint" tag="p">
      <template #termsOfService>
        <NuxtLink class="text-link" :to="$localePath('/terms-and-conditions')">
          {{ $t('register.step.account.info.termsofservice') }}
        </NuxtLink>
      </template>
    </i18n-t>

    <div class="w-full flex flex-col gap-100 items-center">
      <LcCard
        v-for="{ headline, description } in steps"
        :key="headline"
        body-class="pt-050 pr-100"
        class="bg-secondary-secondary"
        shadow="none"
      >
        <template #header>
          <h2 class="headline-h5-headline text-left">
            {{ headline }}
          </h2>
        </template>

        <p class="text-left">
          {{ description }}
        </p>
      </LcCard>
    </div>

    <LcButton class="w-full mt-200" @click="emit('close')">
      {{ $t('highfrequencygame.compliance.modal.cta') }}
    </LcButton>
  </LcModal>
</template>

<script lang="ts" setup>
type Emits = {
  (e: 'close'): void
}

const emit = defineEmits<Emits>()

const { t } = useI18n()

const steps = computed(() => [
  {
    description: t('highfrequencygame.compliance.modal.step1.description'),
    headline: t('highfrequencygame.compliance.modal.step1.headline'),
  },
  {
    description: t('highfrequencygame.compliance.modal.step2.description'),
    headline: t('highfrequencygame.compliance.modal.step2.headline'),
  },
  {
    description: t('highfrequencygame.compliance.modal.step3.description'),
    headline: t('highfrequencygame.compliance.modal.step3.headline'),
  },
])
</script>

<style lang="scss" module>
.modal {
  > * {
    max-width: 22.45rem;
  }
}
</style>
